<template>
    <div>
        <v-card outlined class="mb-5">
            <v-toolbar
                    color="#488ba6"
                    dark
                    flat

            >
                <v-toolbar-title>Make a donation to the Florida Vascular Foundation (Optional)</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

                <p class="m-3">
                    The Florida Vascular Foundation is a not-for-profit entity created to promote education and
                    awareness of vascular diseases among medical professionals and the public in the state of
                    Florida. The Foundation provides travel scholarships to successful resident and fellow
                    candidates from a Florida accredited general/vascular surgical training program who demonstrate
                    a commitment to the study, research, and promotion of public awareness of vascular diseases. The
                    Foundation also provides Next Gen scholarships to medical students from the nine graduate
                    programs across the state of Florida. The scholarships are intended to support travel expenses
                    and lodging to attend the FVS Scientific Sessions.
                </p>

                <v-row>
                    <v-col sm="3">
                        <v-btn-toggle rounded v-model="donation.amount" >
                            <!--<v-button color="primary" dard @click="donAmountSelected(250)" :active="donation.amount === 250"><h4>-->
                            <!--$250</h4>-->
                            <!--</v-button>-->
                            <!--<v-button button @click="donAmountSelected(500)" :active="donation.amount === 500"><h4>-->
                            <!--$500</h4>-->
                            <!--</v-button>-->
                            <!--<v-button button @click="donAmountSelected(1000)" :active="donation.amount === 1000"><h4>-->
                            <!--$1000</h4></v-button>-->
                            <v-btn value="250">
                                $250
                            </v-btn>
                            <v-btn value="500">
                                $500
                            </v-btn>
                            <v-btn value="1000">
                                $1000
                            </v-btn>
                            <!--<v-form inline>-->

                            <!--<div class="col-sm-8 col-xs-2">-->
                            <!--<b-input-group prepend="$" append=".00" size="lg">-->
                            <!--<b-form-input name="otherAmount" id="otherAmount" v-model="holdDonationAmount"-->
                            <!--placeholder="Dollar amount"></b-form-input>-->
                            <!--</b-input-group>-->
                            <!--</div>-->
                            <!--<div class="col-sm-2 col-xs-2">-->
                            <!--<b-button variant="outline-primary" class="ml-lg-4" @click="donAmountSelected()">Add-->
                            <!--</b-button>-->

                            <!--</div>-->

                            <!--</v-form>-->
                        </v-btn-toggle>
                    </v-col>
                    <v-col sm="9">
                        <v-text-field
                                style="max-width: 300px"
                                label="Custom Amount"
                                prepend-icon="mdi-currency-usd"
                                outlined
                                v-model="donation.amount"
                        ></v-text-field>


                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>

    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "Donation",
        data: function () {
            return {
                holdDonationAmount: '',
            }
        },
        computed: {
            ...mapState({
                donator: state => state.donator,
                donation: state => state.donation
            })
        },


    }
</script>

<style scoped>

</style>